// extracted by mini-css-extract-plugin
export default {"PageNav":"PageNav_PageNav__MzWFr","page":"PageNav_page__wRgFn","navi":"PageNav_navi__1VCUe","navi2":"PageNav_navi2__gSuzn"};